import PropTypes from 'prop-types';

const SearchSeoLandingHomecardsIcon = ({ className = null }) => (
  <svg
    width="346"
    height="268"
    viewBox="0 0 346 268"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M278.201 154.715H273.573C262.588 154.715 252.593 148.9 248.1 139.821C239.39 122.197 219.873 109.922 197.191 109.922H153.886V109.971C132.218 110.789 113.746 122.812 105.344 139.821C100.856 148.906 90.8552 154.715 79.8707 154.715H75.242C52.5107 154.715 32.9573 167.045 24.2778 184.73C29.0048 187.066 32.2627 191.934 32.2627 197.565C32.2627 199.741 31.7771 201.794 30.9042 203.638C36.793 207.738 40.6471 214.549 40.6471 222.263C40.6471 225.398 40.0017 228.386 38.8461 231.102C44.8086 236.684 48.5336 244.62 48.5336 253.428C48.5336 258.61 47.2428 263.484 44.9746 267.763H333.954V205.255C333.954 177.341 308.991 154.715 278.195 154.715H278.201Z"
      fill="#F4EFED"
    />
    <path
      d="M177.865 27.8418C145.299 27.8418 118.904 54.0523 118.904 86.3852H236.833C236.833 54.0523 210.432 27.8418 177.872 27.8418H177.865Z"
      fill="#FFCCEF"
    />
    <path
      d="M236.741 86.2383H118.831V267.757H236.741V86.2383Z"
      fill="#FFCCEF"
    />
    <path
      d="M225.51 86.5692C225.51 60.2787 204.285 39.582 178.099 39.582C151.913 39.582 130.688 60.2787 130.688 86.5692"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M178.099 86.5692V39.582"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M178.099 86.5709L210.862 52.7812"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M178.099 86.5709L145.336 52.7812"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M67.2329 98.5684V108.342"
      stroke="#FB6E44"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M72.1203 103.455H62.3467"
      stroke="#FB6E44"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M41.1638 122.639C42.7119 122.639 43.9668 121.384 43.9668 119.836C43.9668 118.288 42.7119 117.033 41.1638 117.033C39.6158 117.033 38.3608 118.288 38.3608 119.836C38.3608 121.384 39.6158 122.639 41.1638 122.639Z"
      fill="#FFCCEF"
    />
    <path d="M345.24 211.162H289.322V267.763H345.24V211.162Z" fill="#FFCCEF" />
    <path
      d="M289.322 211.162H261.365V267.763H289.322V211.162Z"
      fill="#0A0777"
    />
    <path d="M324.543 224.354H310.645V267.763H324.543V224.354Z" fill="white" />
    <path
      d="M314.055 221.456L295.021 224.836L297.171 236.946L316.205 233.566L314.055 221.456Z"
      fill="#FB6E44"
    />
    <path d="M279.763 211.162V154.475H335.682V211.162" fill="white" />
    <path
      d="M279.763 211.162V154.475H335.682V211.162"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path d="M279.763 154.24H251.807V211.161H279.763V154.24Z" fill="#0A0777" />
    <path
      d="M313.307 154.199H299.408V198.377H313.307V154.199Z"
      fill="#FFCCEF"
    />
    <path d="M270.328 167.143H261.384V211.161H270.328V167.143Z" fill="white" />
    <path d="M225.424 86.7969H130.694V267.762H225.424V86.7969Z" fill="white" />
    <path
      d="M206.565 154.611H202.176C197.621 154.611 193.927 158.305 193.927 162.861V196.607C193.927 201.163 197.621 204.856 202.176 204.856H206.565C211.121 204.856 214.815 201.163 214.815 196.607V162.861C214.815 158.305 211.121 154.611 206.565 154.611Z"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M219.425 168.68H205.207C203.67 168.68 202.423 169.925 202.423 171.461C202.423 172.997 203.67 174.243 205.207 174.243H219.425C220.963 174.243 222.21 172.997 222.21 171.461C222.21 169.925 220.963 168.68 219.425 168.68Z"
      fill="#0A0777"
    />
    <path
      d="M204.371 176.8C207.317 176.8 209.706 174.411 209.706 171.464C209.706 168.518 207.317 166.129 204.371 166.129C201.424 166.129 199.035 168.518 199.035 171.464C199.035 174.411 201.424 176.8 204.371 176.8Z"
      fill="#0A0777"
    />
    <path
      d="M204.371 187.897C206.262 187.897 207.795 186.364 207.795 184.473C207.795 182.582 206.262 181.049 204.371 181.049C202.48 181.049 200.947 182.582 200.947 184.473C200.947 186.364 202.48 187.897 204.371 187.897Z"
      fill="#FB6E44"
    />
    <path
      d="M204.371 185.418L199.755 193.415H208.988L204.371 185.418Z"
      fill="#FB6E44"
    />
    <path
      d="M268.536 110.967L307.962 100.675C313.928 99.1176 320.041 102.7 321.598 108.665L282.171 118.957C276.206 120.514 270.093 116.932 268.536 110.967Z"
      fill="#FFCCEF"
    />
    <path
      d="M286.309 110.727L270.807 114.771L259.81 104.703L264.568 103.461L286.309 110.727Z"
      fill="#FFCCEF"
    />
    <path
      d="M279.658 112.946L267.407 116.142C264.525 116.892 261.709 115.669 261.119 113.407L271.624 110.665C275.466 109.663 278.865 109.928 279.658 112.946Z"
      fill="#FFCCEF"
    />
    <path
      d="M282.191 115.479C283.445 120.274 288.147 120.876 293.403 119.505L302.826 117.047L301.13 110.537L282.197 115.479H282.191Z"
      fill="#0A0777"
    />
    <path
      d="M301.124 110.537L302.82 117.047L307.756 115.756L306.908 112.504L306.06 109.246L301.124 110.537Z"
      fill="#0A0777"
    />
    <path
      d="M94.6176 219.713C96.1297 216.148 96.9719 212.239 96.9719 208.126C96.9719 198.008 91.9191 189.083 84.2047 183.711C85.3419 181.295 85.9811 178.596 85.9811 175.744C85.9811 165.387 77.5844 156.996 67.233 156.996C56.8816 156.996 48.4849 165.393 48.4849 175.744C48.4849 178.59 49.1241 181.289 50.2613 183.711C42.5469 189.083 37.4941 198.015 37.4941 208.126C37.4941 209.085 37.5433 210.038 37.6355 210.972C39.5534 214.298 40.6537 218.152 40.6537 222.264C40.6537 225.399 40.0082 228.387 38.8526 231.104C44.8151 236.685 48.5402 244.621 48.5402 253.429C48.5402 258.611 47.2493 263.486 44.9811 267.764H102.652C105.633 262.158 107.323 255.765 107.323 248.979C107.323 237.429 102.436 227.028 94.6176 219.713Z"
      fill="#0A0777"
    />
    <path
      d="M87.1738 245.812V237.342H0.760284V245.812H87.1738Z"
      fill="#FFCCEF"
    />
    <path
      d="M32.724 267.762H9.54395V215.396L21.1371 202.801L32.724 215.396V267.762Z"
      fill="#FFCCEF"
    />
    <path
      d="M78.3834 267.762H55.2095V215.396L66.7964 202.801L78.3834 215.396V267.762Z"
      fill="#FFCCEF"
    />
    <path
      d="M125.543 183.513V153.602"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M143.984 183.513V153.602"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M146.812 154.512H141.163V151.365C141.163 150.498 140.456 149.791 139.589 149.791H129.938C129.072 149.791 128.365 150.498 128.365 151.365V154.512H122.716V151.365C122.716 147.382 125.955 144.148 129.932 144.148H139.583C143.566 144.148 146.799 147.388 146.799 151.365V154.512H146.812Z"
      fill="#0A0777"
    />
    <path
      d="M145.176 183.217H118.726C112.432 183.217 107.33 188.319 107.33 194.613V247.852C107.33 254.146 112.432 259.248 118.726 259.248H145.176C151.47 259.248 156.573 254.146 156.573 247.852V194.613C156.573 188.319 151.47 183.217 145.176 183.217Z"
      fill="#FFCCEF"
    />
    <path
      d="M144.691 267.745C147.036 267.745 148.938 265.843 148.938 263.498C148.938 261.152 147.036 259.25 144.691 259.25C142.345 259.25 140.443 261.152 140.443 263.498C140.443 265.843 142.345 267.745 144.691 267.745Z"
      fill="#0A0777"
    />
    <path
      d="M112.044 267.745C114.39 267.745 116.291 265.843 116.291 263.498C116.291 261.152 114.39 259.25 112.044 259.25C109.698 259.25 107.796 261.152 107.796 263.498C107.796 265.843 109.698 267.745 112.044 267.745Z"
      fill="#0A0777"
    />
    <path
      d="M132.316 183.217H105.866C99.5721 183.217 94.4697 188.319 94.4697 194.613V247.852C94.4697 254.146 99.5721 259.248 105.866 259.248H132.316C138.61 259.248 143.713 254.146 143.713 247.852V194.613C143.713 188.319 138.61 183.217 132.316 183.217Z"
      fill="white"
    />
    <path
      d="M94.4697 198.5H156.572"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M94.4697 213.572H156.572"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M94.4697 229.633H156.572"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M94.4697 243.717H156.572"
      stroke="#0A0777"
      strokeWidth="0.46102"
      strokeMiterlimit="10"
    />
    <path
      d="M108.922 204.626C112.7 204.626 115.763 201.563 115.763 197.785C115.763 194.006 112.7 190.943 108.922 190.943C105.143 190.943 102.08 194.006 102.08 197.785C102.08 201.563 105.143 204.626 108.922 204.626Z"
      fill="#FB6E44"
    />
    <path
      d="M137.629 225.851L117.787 217.285L113.44 227.353L133.283 235.919L137.629 225.851Z"
      fill="#0A0777"
    />
  </svg>
);

SearchSeoLandingHomecardsIcon.propTypes = {
  className: PropTypes.string
};
export default SearchSeoLandingHomecardsIcon;
